import { Star, ShieldCheck, Scissors, DoorOpen, MapPin } from 'lucide-react';
import { useLang } from '../../i18n/LanguageContext';

export const TrustBar = () => {
  const { t } = useLang();
  const items = [
    { icon: ShieldCheck, label: t.trust.authentic },
    { icon: Scissors, label: t.trust.pros },
    { icon: DoorOpen, label: t.trust.walkins },
    { icon: MapPin, label: t.trust.local }
  ];
  return (
    <section className="border-b border-white/5 bg-surface">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-10 lg:py-12 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-x-4 gap-y-9">
        <div className="flex flex-col items-center text-center gap-2 col-span-2 sm:col-span-1" data-testid="trust-item">
          <div className="flex gap-0.5">
            {[...Array(5)].map((_, i) => (
              <Star key={`t-star-${i}`} size={16} fill="#c7a154" color="#c7a154" />
            ))}
          </div>
          <span className="text-xs sm:text-[13px] font-semibold uppercase tracking-wide text-white/75 leading-snug">
            {t.trust.rating}
          </span>
        </div>
        {items.map((it) => (
          <div key={it.label} className="flex flex-col items-center text-center gap-2.5" data-testid="trust-item">
            <it.icon size={24} className="text-gold" />
            <span className="text-xs sm:text-[13px] font-semibold uppercase tracking-wide text-white/75 leading-snug">
              {it.label}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
};
